export function parseViewerRequest(search) {
  const params = new URLSearchParams(search)
  const bucket = params.get('bucket')
  const key = params.get('key')
  const hasControlCharacters = key && Array.from(key).some(char =>
    char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)
  if (params.getAll('bucket').length !== 1 || params.getAll('key').length !== 1 ||
      !bucket || !key || !/\.pdf$/i.test(key) || hasControlCharacters) {
    throw new Error('The report link must include one bucket and one PDF object key.')
  }
  return { bucket, key }
}

